import React from 'react'
import classNames from 'classnames'
import { CircleInfoIcon } from '@/atoms/Icons/CircleInfoIcon'
import { CaptionSM, CaptionXS, EyebrowXS, TitleXS } from '@/atoms/Text'
import { useTranslate } from '@/utils/translate/translate-client'
import { BaseTooltip, BaseTooltipProps } from '.'

interface SpecificTimesToolTipProps extends BaseTooltipProps {
  extraSmall?: boolean
  copy: string[]
  triggerText?: string
}

export const SpecificTimesToolTip: React.FC<SpecificTimesToolTipProps> = ({
  iconSize = 16,
  className,
  buttonClassName,
  panelClassName,
  panelPosition = 'CENTER',
  isIconOnly,
  buttonStyle,
  titleText: titleTextProp,
  children,
  buttonColor,
  textColor,
  extraSmall = false,
  copy,
}) => {
  const { t } = useTranslate('tickets')
  const titleText = titleTextProp || t('forSpecificTimes', 'FOR SPECIFIC TIMES')

  const trigger = (
    <>
      {!isIconOnly && children ? (
        children
      ) : (
        <>
          {!extraSmall && (
            <EyebrowXS color={textColor} className={classNames('@md:!photon-eyebrow-md text-black/80')}>
              {titleText}
            </EyebrowXS>
          )}
          {extraSmall && (
            <CaptionXS color={textColor} className={'text-black/80'}>
              {titleText}
            </CaptionXS>
          )}
        </>
      )}
      <CircleInfoIcon size={iconSize} color={buttonColor || 'black'} />
    </>
  )

  const content = (() => {
    return (
      <>
        <TitleXS color="core-gray-950" weight="bold">
          {t('specificShowTimesDetails', 'Specific Showtimes Details')}
        </TitleXS>
        <div className="mt-2 flex flex-col gap-0.5 text-[0.688rem] leading-[16px]">
          <CaptionSM color="core-gray-700" className="text-pretty">
            {t(
              'thisDiscountIsAvailableOnSelectShowtimes',
              'This discount is available at Angel Partnering Theaters on the following select showtimes.',
            )}
          </CaptionSM>

          <ul className="mt-2 list-disc pl-4">
            {copy.map((item) => (
              <li key={item} className="text-core-gray-950">
                <CaptionSM className="font-semibold">{item}</CaptionSM>
              </li>
            ))}
          </ul>
        </div>
      </>
    )
  })()

  return (
    <BaseTooltip
      className={className}
      buttonClassName={buttonClassName}
      panelClassName={panelClassName}
      panelPosition={panelPosition}
      isIconOnly={isIconOnly}
      removeBorder={true}
      buttonStyle={buttonStyle}
      trigger={trigger}
      content={content}
    />
  )
}
